export default {
  paper: {
    borderRadius: 0
  },
};

